import { React, useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import styled from 'styled-components';
import { useLanguage } from '../../../Context/LanguageContext';

import LockerInfo from '../../../Component/MainComponent/LockerInfo.js';
import LockerAddModal from '../LockerModel/LockerAddModal.js';
import LockerStartModal from '../LockerModel/LockerStartModal.js';
import LockerChangeNameModal from '../LockerModel/LockerChangeNameModal.js';
import LockerUsingStopModal from '../LockerModel/LockerUsingStopModal.js';
import LockerHistoryModal from '../LockerModel/LockerHistoryModal.js';

import FetchModule from '../../Share/Network/FetchModule.js';
import LockerExtendsModal from '../LockerModel/LockerExtendsModal.js';
import LockerDivisionInput from '../../../Component/LockerComponent/LockerDivisionInput.js';

import EmptySign from '../../../image/EmptySign.png';
import CustomAlert from '../../Share/Normal/CustomAlert.js';

const LockerView = () => {
  const history = useHistory();
  const { t } = useLanguage();

  const [isClickedAdd, setIsClickedAdd] = useState(false);
  const [isClickedChangeName, setIsClickedChangeName] = useState(false);
  const [isClickedStart, setIsClickedStart] = useState(false);
  const [isClickedStop, setIsClickedStop] = useState(false);
  const [isClickedHistory, setIsClickedHistory] = useState(false);
  const [isClickedExtend, setIsClickedExtend] = useState(false);
  const [lockerData, setLockerData] = useState([]);
  const [index, setIndex] = useState(-1);
  const [rendering, setRendering] = useState(false);
  const [lockerDivisions, setLockerDivisions] = useState([]);
  const [totalLockers, setTotalLockers] = useState([]);
  const [isInProgressAddLocker, setIsInProgressAddLocker] = useState(false);
  const [isInProgressDeleteLocker, setIsInProgressDeleteLocker] = useState(false);
  const [isInProgressLockerDivision, setIsInProgressLockerDivision] = useState(false);
  const [selectedAddLockerDivision, setSelectedAddLockerDivision] = useState({ id: 0, name: '전체' });
  const [isClickedLockerDivisionId, setIsClickedLockerDivisionId] = useState(0);
  const [newLockerName, setNewLockerName] = useState('');
  const [isClickedAddLockerDivision, setIsClickedAddLockerDivision] = useState(false);

  const [text, setText] = useState('');
  const [lockerIndex, setLockerIndex] = useState(-1);
  const [isViewCustomAlert, setIsViewCustomAlert] = useState(false);

  const [nowClickComponent, setNowClickComponent] = useState(null);

  const AddModalRef = useRef();
  const NameModalRef = useRef();
  const StartModalRef = useRef();
  const LockerRef = useRef([]);

  // 락커 데이터 받아오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('locker/', 'GET');

        if (responseData.status === 200) {
          let divisions = responseData.data.lockerDivisions.slice();
          let lockers = responseData.data.lockers.slice();
          let newTotalLockers = [];

          divisions.unshift({ id: 0, name: t('main.locker.all') });

          for (let i = 0; i < divisions.length; i++) {
            let newDivision = {
              id: divisions[i].id,
              name: divisions[i].name,
              lockers: []
            }

            newTotalLockers.push(newDivision);
          }

          for (let i = 0; i < lockers.length; i++) {
            if (lockers[i].lockerDivisionId === undefined || lockers[i].lockerDivisionId === 0) newTotalLockers[0].lockers.push(lockers[i]);
            else {
              for (let j = 0; j < newTotalLockers.length; j++) {
                if (lockers[i].lockerDivisionId === newTotalLockers[j].id) {
                  newTotalLockers[j].lockers.push(lockers[i]);
                  break;
                }
              }
            }
          }

          setLockerDivisions(divisions);
          setTotalLockers(newTotalLockers);
        }
        else if (responseData.status === 401) {
          alert(t('main.locker.loginRequired'));
          history.push('/');
        }
      }
    )();
  }, [history, rendering])

  // 락커 구분 이름 결정 //
  function decideDivisionText() {
    if (isClickedLockerDivisionId === 0) return t('main.locker.all');
    else {
      for (let i = 0; i < lockerDivisions.length; i++) {
        if (lockerDivisions[i].id === isClickedLockerDivisionId) return lockerDivisions[i].name;
      }
    }
  }

  function modalExitClick() {
    setSelectedAddLockerDivision({ id: 0, name: '전체' });
    setIsClickedAdd(false);
  }

  function addModalSaveClick() {
    let count = AddModalRef.current.getValue();

    if (count === 0) {
      alert('추가할 락커 개수를 입력해주세요');
      return;
    }
    else if (isInProgressAddLocker) {
      alert('락커 저장 진행중입니다');
      return;
    }

    setIsInProgressAddLocker(true);

    let requestData = {
      count: count,
      lockerDivisionId: selectedAddLockerDivision.id === 0 ? null : selectedAddLockerDivision.id
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('locker/save', 'POST', requestData);

        if (responseData.status === 200) {
          setRendering(!rendering);
          setIsInProgressAddLocker(false);
          setIsClickedAdd(false);
        }
        else if (responseData.status === 401) {
          alert(t('main.locker.loginRequired'));
          history.push('/');
          setIsInProgressAddLocker(false);
        }
        else {
          alert('락커 추가에 실패했습니다\n잠시 후 다시시도해주세요');
          setIsInProgressAddLocker(false);
        }
      }
    )();
  }

  function changeModalSaveClick(name) {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.patchData('locker/modify/name/'
          + totalLockers[index].lockers[lockerIndex].id
          + '/'
          + name, 'PATCH');

        if (responseData.status === 200) {
          setRendering(!rendering);
          setIsClickedChangeName(false);
          setIndex(-1);
          clickMoreButton();
        }
        else if (responseData.status === 204) { }
        else if (responseData.status === 401) {
          alert(t('main.locker.loginRequired'));
          history.push('/');
        }
      }
    )();
  }

  function clickMoreButton() {
    for (let i = 0; i < totalLockers.length; i++) {
      for (let j = 0; j < totalLockers[i].lockers.length; j++) {
        LockerRef.current[i][j].setClickedMore(false);
      }
    }
  }

  function clickUsageHistory(index, lockerIndex) {
    setIndex(index);
    setLockerIndex(lockerIndex);
    setIsClickedHistory(true);
  }

  function clickChangeState(index, lockerIndex) {
    if (totalLockers[index].lockers[lockerIndex].stateCode === 'Using') {
      setText(t('main.locker.endUsageFirst'));
      setIsViewCustomAlert(true);
      return;
    }
    else if (totalLockers[index].lockers[lockerIndex].stateCode === 'Invalid') {
      setText(t('main.locker.alreadyLocked'));
      setIsViewCustomAlert(true);
      return;
    }

    let state = '';

    if (totalLockers[index].lockers[lockerIndex].stateCode === 'Empty') state = 'Invalid';

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.patchData('locker/modify/'
          + totalLockers[index].lockers[lockerIndex].id
          + '/'
          + state, 'PATCH');

        if (responseData.status === 200) {
          setRendering(!rendering);
          clickMoreButton();
        }
        else if (responseData.status === 204) { }
        else if (responseData.status === 401) {
          alert(t('main.locker.loginRequired'));
          history.push('/');
        }
      }
    )();
  }

  function clickDeleteLocker(index, lockerIndex) {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.deleteData('locker/delete/'
          + totalLockers[index].lockers[lockerIndex].id, 'DELETE');

        if (responseData.status === 200) {
          setRendering(!rendering);
          clickMoreButton();
        }
        else if (responseData.status === 205) {
          setText(t('main.locker.lockerInUse'));
          setIsViewCustomAlert(true);
        }
        else if (responseData.status === 401) {
          alert(t('main.locker.loginRequired'));
          history.push('/');
        }
      }
    )();
  }

  function clickChangeName(index, lockerIndex) {
    setIndex(index);
    setLockerIndex(lockerIndex);
    setIsClickedChangeName(true);
  }

  function clickUsingStartOrEndOrChangeValid(index, lockerIndex) {
    setIndex(index);
    setLockerIndex(lockerIndex);

    let state = '';

    if (totalLockers[index].lockers[lockerIndex].stateCode === 'Invalid') {
      state = 'Empty';

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.patchData('locker/modify/'
            + totalLockers[index].lockers[lockerIndex].id
            + '/'
            + state, 'PATCH');

          if (responseData.status === 200) {
            setRendering(!rendering);
            clickMoreButton();
          }
          else if (responseData.status === 204) { }
          else if (responseData.status === 401) {
            alert(t('main.locker.loginRequired'));
            history.push('/');
          }
        }
      )();
      return;
    }

    if (totalLockers[index].lockers[lockerIndex].stateCode === 'Using') setIsClickedStop(true);
    else if (totalLockers[index].lockers[lockerIndex].stateCode === 'Empty') setIsClickedStart(true);
  }

  function startModalSaveClick() {
    let storeId = parseInt(window.sessionStorage.getItem('StoreId'));
    let lockerId = totalLockers[index].lockers[lockerIndex].id;
    let memberId = StartModalRef.current.getMemberData().memberId;
    let card = StartModalRef.current.getCard();
    let cash = StartModalRef.current.getCash();
    let point = StartModalRef.current.getPoint();
    let approvalDate = moment().format('YYYY-MM-DDTHH:mm:ss');
    let startDate = StartModalRef.current.getStartDate() === '' ? '' : StartModalRef.current.getStartDate().format('YYYY-MM-DD') + 'T' + approvalDate.split('T')[1];
    let endDate = StartModalRef.current.getEndDate() === '' ? '' : StartModalRef.current.getEndDate().format('YYYY-MM-DD') + 'T23:59:59';

    if (startDate === '') {
      setText(t('main.locker.selectStartDate'));
      setIsViewCustomAlert(true);
      return;
    }
    else if (endDate === '') {
      setText(t('main.locker.selectEndDate'));
      setIsViewCustomAlert(true);
      return;
    }
    else if (memberId === 0 || memberId === undefined) {
      setText(t('main.locker.selectMember'));
      setIsViewCustomAlert(true);
      return;
    }

    let data = {
      storeId: storeId,
      lockerId: lockerId,
      memberId: memberId,
      startDate: startDate,
      endDate: endDate,
      approvalDate: approvalDate,
      cardPrice: card === 0 ? card : card.replaceAll(',', ''),
      cashPrice: cash === 0 ? cash : cash.replaceAll(',', ''),
      point: point === 0 ? point : point.replaceAll(',', '')
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('locker/start', 'POST', data);

        if (responseData.status === 200) {
          setRendering(!rendering);
          setIsClickedStart(false);
          setIndex(-1);
          clickMoreButton();
        }
        else if (responseData.status === 201) {
          setText(responseData.error);
          setIsViewCustomAlert(true);
        }
        else if (responseData.status === 204) {
          if (responseData.error === 'Locker Already Using') {
            setText(t('main.locker.alreadyInUse'));
            setIsViewCustomAlert(true);
          }
          else if (responseData.error === 'Invalid Using') {
            setText(t('main.locker.unavailableLocker'));
            setIsViewCustomAlert(true);
          }
          else if (responseData.error === 'Invalid User Data') {
            setText(t('main.locker.invalidMemberInfo'));
            setIsViewCustomAlert(true);
          }
        }
        else if (responseData.status === 401) {
          alert(t('main.locker.loginRequired'));
          history.push('/');
        }
      }
    )();
  }

  function stopModalSaveClick() {
    let requestData = {
      usageId: totalLockers[index].lockers[lockerIndex].usageId
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('locker/stop/', 'POST', requestData);

        if (responseData.status === 200) {
          alert(t('main.locker.usageEnded'));
          setRendering(!rendering);
          setIsClickedStop(false);
          setIndex(-1);
          clickMoreButton();
        }
        else if (responseData.status === 204) { }
        else if (responseData.status === 401) {
          alert(t('main.locker.loginRequired'));
          history.push('/');
        }
      }
    )();
  }


  // 사용 연장버튼 클릭시 //
  function onClickExtendsButton(index, lockerIndex) {
    setIndex(index);
    setLockerIndex(lockerIndex);
    setIsClickedExtend(true);
  }

  // 락커 추가 버튼 클릭시 //
  function onClickLockerDivisionAddButton() {
    if (isClickedAddLockerDivision) {
      if (newLockerName === '') {
        alert('추가할 락커구분 이름을 입력해주세요');
        return;
      }
      else if (isInProgressLockerDivision) {
        alert('추가를 진행중입니다');
        return;
      }

      setIsInProgressLockerDivision(true);

      let requestData = {
        name: newLockerName
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('locker/division/save', 'POST', requestData);

          if (responseData.status === 200) {
            let divisions = lockerDivisions.slice();

            divisions.push(responseData.data);
            setLockerDivisions(divisions);
            setIsInProgressLockerDivision(false);
            setIsClickedAddLockerDivision(false);
          }
        }
      )();
    }
    else setIsClickedAddLockerDivision(true);
  }

  // 락커 구분 삭제 버튼 클릭시 //
  function onClickLockerDivisionDeleteButton() {
    if (isInProgressDeleteLocker) {
      alert('락커 구분 삭제를 진행중입니다');
      return;
    }

    setIsInProgressDeleteLocker(true);

    let requestData = {
      lockerDivisionId: isClickedLockerDivisionId
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('locker/division/delete', 'POST', requestData);

        if (responseData.status === 200) {
          alert('삭제가 완료되었습니다');
          setRendering(!rendering);
          setIsClickedLockerDivisionId(0);
          setIsInProgressDeleteLocker(false);
        }
        else if (responseData.status === 201) {
          alert('락커가 존재합니다\n락커를 모두 삭제 후 다시시도해주세요');
          setIsInProgressDeleteLocker(false);
        }
        else {
          alert('락커 구분 삭제가 실패하였습니다\n잠시 후 다시시도해주세요');
          setIsInProgressDeleteLocker(false);
        }
      }
    )();
  }

  return (
    <TopLevelWrapper>
      {isViewCustomAlert && <CustomAlert text={text} closeFn={() => setIsViewCustomAlert(false)} />}
      {
        isClickedAdd &&
        <LockerAddModal
          ref={AddModalRef}
          lockerDivisions={lockerDivisions}
          selectedAddLockerDivision={selectedAddLockerDivision}
          setSelectedAddLockerDivision={setSelectedAddLockerDivision}
          exitClick={modalExitClick}
          saveClick={addModalSaveClick} />
      }
      {isClickedChangeName && <LockerChangeNameModal ref={NameModalRef} data={totalLockers} index={index} lockerIndex={lockerIndex} exitClick={() => setIsClickedChangeName(false)} saveClick={changeModalSaveClick} />}
      {isClickedStop && <LockerUsingStopModal data={totalLockers[index].lockers[lockerIndex]} exitClick={() => setIsClickedStop(false)} saveClick={stopModalSaveClick} />}
      {isClickedStart && <LockerStartModal ref={StartModalRef} lockerData={totalLockers[index].lockers[lockerIndex]} exitClick={() => setIsClickedStart(false)} saveClick={startModalSaveClick} />}
      {isClickedHistory && <LockerHistoryModal data={totalLockers[index].lockers[lockerIndex]} exitClick={() => setIsClickedHistory(false)} />}
      {isClickedExtend && <LockerExtendsModal memberData={{ name: totalLockers[index].lockers[lockerIndex].userName }} recentlyMembership={undefined} lockerData={totalLockers[index].lockers[lockerIndex]} lockerRendering={() => setRendering(!rendering)} closeFn={() => setIsClickedExtend(false)} />}

      <TitleWrapper>
        <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#232323' cursor='default'>{t('main.locker.title')}</Text>
        <ExplanationWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#777777' cursor='default'>{t('main.locker.desc')}</Text>
          <Text fontFamily='NotoSansKR-Medium' fontSize={12} color='#FF8B48' cursor='pointer' onClick={() => history.push('/locker')} style={{ whiteSpace: 'nowrap' }}>{t('main.locker.detail')}</Text>
        </ExplanationWrapper>
      </TitleWrapper>

      <LockerDivisionButtonWrapper>
        {
          lockerDivisions.map((data, index) => (
            <LockerDivisionButton
              key={'LockerDivision-' + index}
              isClicked={isClickedLockerDivisionId === data.id}
              onClick={() => setIsClickedLockerDivisionId(data.id)}>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={isClickedLockerDivisionId === data.id ? '#FFFFFF' : '#CBCBCB'} cursor='pointer'>{data.name}</Text>
            </LockerDivisionButton>
          ))
        }
        {isClickedAddLockerDivision && <LockerDivisionInput value={newLockerName} setValue={setNewLockerName} />}
      </LockerDivisionButtonWrapper>

      <TotalViewBoxWrapper>
        <ViewBox>
          {
            (isClickedLockerDivisionId === 0
              ? totalLockers.reduce((sum, division) => sum + division.lockers.length, 0)
              : (totalLockers.find(division => division.id === isClickedLockerDivisionId)?.lockers.length || 0)
            ) === 0 ?
              <NoneLockerBox>
                <EmptyImage src={EmptySign} />
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#CBCBCB' cursor='default'>{t('main.locker.noLocker')}</Text>
              </NoneLockerBox>
              :
              <DivisionInfoBox>
                {
                  totalLockers.map((data, index) => (
                    (isClickedLockerDivisionId === 0 || data.id === isClickedLockerDivisionId) &&
                    <InfoBoxWrapper key={'totalLocker-' + index}>
                      {
                        (isClickedLockerDivisionId === 0 && index !== 0) &&
                        <DivisionNameBoxWrapper>
                          <DivisionNameBox>
                            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='default'>{data.name}</Text>
                          </DivisionNameBox>
                        </DivisionNameBoxWrapper>
                      }
                      <InfoBox>
                        {
                          data.lockers.map((locker, lockerIndex) => (
                            <LockerInfo
                              key={lockerIndex}
                              data={locker}
                              index={index}
                              lockerIndex={lockerIndex}
                              ref={element => {
                                if (!LockerRef.current[index]) {
                                  LockerRef.current[index] = [];
                                }
                                LockerRef.current[index][lockerIndex] = element;
                              }}
                              clickUsageHistoryFn={clickUsageHistory}
                              clickFunctionFn={clickUsingStartOrEndOrChangeValid}
                              clickChangeStateFn={clickChangeState}
                              clickDeleteLockerFn={clickDeleteLocker}
                              clickChangeNameFn={clickChangeName}
                              clickExtendFn={onClickExtendsButton} />
                          ))
                        }
                      </InfoBox>
                      {(isClickedLockerDivisionId === 0 && totalLockers.length - 1 !== index) && <DivisionLine />}
                    </InfoBoxWrapper>
                  ))
                }
              </DivisionInfoBox>
          }
        </ViewBox>
      </TotalViewBoxWrapper>
    </TopLevelWrapper>
  )
};

export default LockerView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 1054px;

  border-radius: 30px;
  background-color: #FFFFFF;
  box-shadow: 0px 40px 50px rgba(240, 232, 227, 0.5);
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 28px;
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 1000px;
  margin-top: 4px;
`;

const TotalViewBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 1000px;

  margin-top: 12px;
  margin-bottom: 96px;
`;

const ViewBox = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  padding: 28px 0px;

  width: 100%;

  gap: 16px;
`;

const LockerDivisionButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  margin-top: 12px;

  width: calc(100% - 50px);

  flex-wrap: wrap;

  gap: 10px;
`;

const LockerDivisionButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 5px 20px;

  border: 1px solid ${props => props.isClicked ? '#FF8B48' : '#DFDFDF'};
  border-radius: 10px;
  background-color: ${props => props.isClicked ? '#FF8B48' : '#FFFFFF'};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const InfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: row;

  flex-wrap: wrap;

  width: 100%;

  gap: 16px;
`;

const DivisionInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
`;

const DivisionNameBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-bottom: 16px;

  width: 100%;
`;

const DivisionNameBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0px 10px;

  height: 21px;

  border-radius: 5px;
  background-color: #969696;
`;

const DivisionLine = styled.div`
  margin: 35px 0px;

  width: 100%;
  height: 1px;

  border-radius: 2px;
  background-color: #D9D9D9;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;

const NoneLockerBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 10px;
  padding: 60px 0px;

  width: 100%;
`;

const EmptyImage = styled.img`
  width: 148px;
  height: 62px;
`;
